import { render, staticRenderFns } from "./footerPc.vue?vue&type=template&id=4ac4031e&scoped=true"
import script from "./footerPc.vue?vue&type=script&lang=js"
export * from "./footerPc.vue?vue&type=script&lang=js"
import style0 from "./footerPc.vue?vue&type=style&index=0&id=4ac4031e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4031e",
  null
  
)

export default component.exports